import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { primaryNavItems } from "../data/navLinks";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = primaryNavItems;

  const handleNavClick = (item) => {
    if (item.path.includes("#")) {
      const [path, hash] = item.path.split("#");
      if (location.pathname !== path) {
        window.location.href = item.path;
      } else {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
    setIsOpen(false);
  };

  return (
    <nav className="bg-brand-dark-blue text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-3 sm:px-4 min-w-0 max-w-full">
        <div className="flex justify-between items-center gap-2 sm:gap-3 py-4 min-w-0 w-full">
          {/* Logo — min-w-0 + max-w aby na úzkych displejoch neodsunulo burger za overflow */}
          <Link
            to="/"
            className="flex items-center hover:opacity-80 transition-opacity min-w-0 flex-1 md:flex-initial pr-1"
            data-testid="nav-logo"
          >
            <img
              src="/logo-bile.svg"
              alt="PETO SLOBODA"
              className="h-10 sm:h-12 w-auto max-w-full object-contain object-left"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => {
              const isActive =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname === item.path ||
                    location.pathname.startsWith(item.path + "/");

              return item.path.includes("#") ? (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item)}
                  className={`text-lg font-semibold hover:text-brand-orange transition-colors ${
                    isActive ? "text-white" : "text-gray-400"
                  }`}
                  data-testid={`nav-${item.id}`}
                >
                  {item.name}
                </button>
              ) : (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`text-lg font-semibold hover:text-brand-orange transition-colors ${
                    isActive ? "text-white" : "text-gray-400"
                  }`}
                  data-testid={`nav-${item.id}`}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="md:hidden p-2 min-w-[44px] min-h-[44px] flex items-center justify-center shrink-0 text-white relative z-10"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Otvoriť menu"
            aria-expanded={isOpen}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => {
                const isActive =
                  item.path === "/"
                    ? location.pathname === "/"
                    : location.pathname === item.path ||
                      location.pathname.startsWith(item.path + "/");

                return item.path.includes("#") ? (
                  <button
                    key={item.id}
                    onClick={() => handleNavClick(item)}
                    className={`text-left text-lg font-semibold hover:text-brand-orange transition-colors ${
                      isActive ? "text-white" : "text-gray-400"
                    }`}
                    data-testid={`mobile-nav-${item.id}`}
                  >
                    {item.name}
                  </button>
                ) : (
                  <Link
                    key={item.id}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`text-lg font-semibold hover:text-brand-orange transition-colors ${
                      isActive ? "text-white" : "text-gray-400"
                    }`}
                    data-testid={`mobile-nav-${item.id}`}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
